<template>
    <DnModal>
        <template
            v-for="name in Object.keys($slots)"
            v-slot:[name]="scope"
        >
            <slot
                :name="name"
                v-bind="scope"
            />
        </template>

        <template #close-button-label>
            <BaseIcon icon="cross" />
        </template>
    </DnModal>
</template>


<script setup>
import DnModal from '@digitalnatives/modal';
</script>

<style src="./BaseModal.less" lang="less"></style>
